var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    fill: "#FFB74D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 4C6.46171 4 4 6.46338 4 9.5C4 12.5366 6.46338 15 9.5 15C12.5383 15 15 12.5366 15 9.5C15 6.46338 12.5366 4 9.5 4ZM9.5 13.78C7.14023 13.78 5.22166 11.8614 5.22166 9.50167C5.22166 7.1419 7.14023 5.22334 9.5 5.22334C11.8598 5.22334 13.7783 7.1419 13.7783 9.50167C13.7783 11.8614 11.8581 13.78 9.5 13.78Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.30954 7.38477H8.23047V9.80706L10.0068 11.6155L10.7689 10.8396L9.30954 9.35382V7.38477Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.e5d76d4fa380c14d73b8d70955b8d23f.svg";
export { ForwardRef as ReactComponent };